import { Directive, ElementRef, Input, HostListener } from '@angular/core';

@Directive({
    selector: '[tooltipCustom]'
})

export class TooltipeDirective  {
    supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;

    @Input() tooltipCustom: any;
  
  
    @HostListener('mouseenter', ['$event']) show(event) {
        if(!this.supportsTouch){
            event.target.classList.add('show-tooltip')
        }

        
        
   
    }
    @HostListener('mouseleave', ['$event']) hide(event) {
        event.target.classList.remove('show-tooltip')

        

       
    }


}



// WEBPACK FOOTER //
// ./src/app/directives/tooltip.directive.ts